<mat-toolbar class="subtitulo">Matricula de beneficiário na Turma</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form [formGroup]="form" role="form">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <div fxFlex="35%" fxLayoutGap="20px">
                    <mat-form-field style="width: 100%;" fxLayoutGap="20px" fxFlexOffset="20px">
                        <input matInput maxlength="255" name="beneficiario" placeholder="Nome do Benefiário:"
                            formControlName="beneficiario">
                    </mat-form-field>
                </div>

                <div fxFlex="15%" fxLayoutGap="20px" fxFlexOffset="40px">
                    <mat-form-field style="width: 100%;">
                        <input matInput name="cpf" placeholder="CPF:" formControlName="cpf"
                            [textMask]="{mask: mascaraCpf}">
                    </mat-form-field>
                </div>
                <div fxFlex="15%" fxLayoutGap="20px" fxFlexOffset="40px">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Turma:</mat-label>
                        <mat-select formControlName="idTurma" name="idTurma" (selectionChange)="changeTurma()">
                            <mat-option [value]="null">Selecione</mat-option>
                            <mat-option *ngFor="let item of turmas" [value]="item.id">
                                {{item.descricao}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div fxFlex="15%" fxLayoutGap="20px" fxFlexOffset="40px">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Oficina:</mat-label>
                        <mat-select formControlName="idOficina" name="idOficina">
                            <mat-option [value]="null">Selecione</mat-option>
                            <mat-option *ngFor="let item of atividadesFiltrada" [value]="item.id">
                                {{item.descricao}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;"
                fxFlexFill>
                <button mat-raised-button fxFlex="20%" (click)="consultar()">
                    CONSULTAR
                </button>
                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>
            </div>
        </form>
        <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">
            <ng-container matColumnDef="turma">
                <th mat-header-cell *matHeaderCellDef> Turma </th>
                <td mat-cell *matCellDef="let element" style="width: 35%"> {{ element.turma?.descricao }} </td>
            </ng-container>

            <ng-container matColumnDef="aluno">
                <th mat-header-cell *matHeaderCellDef> Beneficiário </th>
                <td mat-cell *matCellDef="let element" style="width: 35%"> {{ element.aluno?.pessoaFisica?.nome }} </td>
            </ng-container>

            <ng-container matColumnDef="dataInicio">
                <th mat-header-cell *matHeaderCellDef> Data de início </th>
                <td mat-cell *matCellDef="let element" style="width: 15%"> {{element.dataInicio | dataSimples }} </td>
            </ng-container>

            <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef> Ações </th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="perfilAcesso.deleta" mat-button (click)="deletar(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                        <mat-icon>search</mat-icon>
                    </button>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [length]="numberItens" [pageSizeOptions]="[10, 20, 40, 60, 80, 100]" showFirstLastButtons
                (page)="onEventPaginate($event)"></mat-paginator>
        </div>
        <ng-template #tabelaSemDados>
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{msg}}
            </div>
        </ng-template>

        <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px"
            style="padding-top: 50px">
            <div>
                <button matTooltip="Adicionar nova matricula" mat-fab color="primary"
                    [routerLink]="['/matriculas/cadastrar']" routerLinkActive="router-link-active">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>